import {withTranslation} from "react-i18next";
import React from "react";
import Icon from "src/components/Icon";

interface SearchBtnProps {
  text?: string;
  ariaLabel?: string;
  title?: string;
  buttonColor: string;
  handleSearchButtonClick: () => void;
  t: (key: string) => string;
}

const SearchBtn = ({handleSearchButtonClick, t, buttonColor, text, ariaLabel, title}: SearchBtnProps) => {
  return (
    <button
      className="faq-widget-header-search-btn"
      style={{border: `1px solid ${buttonColor}`}}
      onClick={() => handleSearchButtonClick()}
      aria-label={ariaLabel}
      title={title}
    >
      <Icon name="search" iconSize="16px" color="black" />
      {text || t("SEARCH")}
    </button>
  );
};

const SearchBtnWithTranslation = withTranslation()(SearchBtn);
export default SearchBtnWithTranslation;
